import type { EquipCollectionType } from '@/types/equip'

export let equipCollection: EquipCollectionType = {}
export function setEquipCollection(data: EquipCollectionType) {
  equipCollection = data
}